<template>
  <div class="wrapper">
    <ArticleLayout>
      <template #default>
        Fam Koelink B.V
      </template>
      <template #body>
        de pallet app (hierna <b>"Fam Koelink B.V"</b>) is de verantwoordelijke voor depersoonsgegevensverwerking, zoals
        omschreven in deze privacyverklaring.
        <br>
        <br>
        Postadres: Blaak 520, 3011 TA Rotterdam
        <br>
        E-mailadres: info@depalletapp.nl
        <br>
        Telefoonnummer: 010 307 71 15
        <br>
        KvK-nummer: 87269686
        <br>
        Btw-nummer: NL864252006B01
        <br>
        <br>
        Fam Koelink B.V
        stelt deze privacyverklaring op om inzicht te geven over het gebruikvan persoonsgegevens op de pallet app (hierna
        <b>"de website"</b>), en alle aan dewebsite gerelateerde domeinen.
        <br>
        <br>
        Onder persoonsgegevens worden alle gegevens verstaan
        waarmee een individugeïdentificeerd kan worden, zoals de naam, het klantnummer en de persoonlijkecontactgegevens.
        Gegevens die niet persoonlijk zijn, maar in combinatie metpersoonlijke gegevens tot identificatie van de gebruiker
        leiden, hebben tevens tegelden als persoonsgegevens.
        <br>
        <br>
        Deze privacyverklaring is van toepassing op iedereen die de
        website bezoekt, of openig andere wijze met de website communiceert (hierna <b>"de gebruiker"</b>).
        <br>
        <br>
        Fam Koelink B.V
        verbindt zich ertoe de Verordening (EU) 2016/679 van hetEuropees Parlement en de Raad van 27 april 2016
        betreffende de bescherming vannatuurlijke personen in verband met de verwerking van persoonsgegevens enbetreffende
        het vrije verkeer van die gegevens en tot intrekking van Richtlijn95/46/EG (algemene verordening
        gegevensbescherming) en de UitvoeringswetAlgemene verordening gegevensbescherming in acht te nemen.
        <br>
        <br>
        Fam Koelink B.V
        draagt zorg voor passende maatregelen ter bescherming van deverzamelde en verwerkte persoonsgegevens.In het geval
        van vragen naar aanleiding van deze privacyverklaring, of andere aanprivacybescherming gerelateerde vragen, kan
        contact opgenomen worden via:
        <br>
        info@depalletapp.nl.
        <br>
        <br>
        <i>
          Deze privacyverklaring is voor het laatst bijgewerkt op: 3
          augustus 2023.
        </i>
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        1. WELKE GEGEVENS WORDEN VERWERKT
      </template>

      <template #body>
        Bij het gebruik van de website of diensten van Fam Koelink B.V kunnen de volgendepersoonsgegevens worden verzameld
        en verwerkt:

        <p class="dent">
          Voor- en achternaam, bezorg- en woonadres, telefoonnummer, e-mailadres, IP-adres, Gegevens over de activiteiten
          van de gebruiker van de app.
        </p>
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        2. DOEL VAN DE VERWERKING VAN DE GEGEVENS
      </template>

      <template #body>
        Met inachtneming van de privacywetgeving, worden de persoonsgegevens van degebruikers uitsluitend gebruikt voor de
        volgende doeleinden:

        <p class="dent">
          Ter beschikbaarstelling van aanbod die aansluiten bij de interesses van degebruiker.
        </p>

        In navolging van artikel 6 Algemene Verordening Gegevensbescherming heeft deverwerking van persoonsgegevens voor
        de bovengenoemde doeleinden de volgendegrondslag:

        <ul>
          <li>
            De gebruiker heeft toestemming gegeven voor de verwerking van zijnpersoonsgegevens. (lid 1 sub a) De gegeven
            toestemming kan te allen tijdedoor de gebruiker worden ingetrokken.
          </li>

          <li>
            De verwerking is noodzakelijk voor de uitvoering van een overeenkomst met degebruiker. (lid 1 sub b)
          </li>

          <li>
            De verwerking is noodzakelijk vanwege een wettelijke verplichting van deverwerkingsverantwoordelijke. (lid 1
            sub c)
          </li>

          <li>
            De verwerking is noodzakelijk om vitale belangen te beschermen. (lid 1 sub d)
          </li>

          <li>
            De verwerking is noodzakelijk om een taak van algemeen belang of openbaargezag uit te oefenen. (lid 1 sub e)
          </li>

          <li>
            De verwerking is noodzakelijk voor de behartiging van de gerechtvaardigdebelangen van de
            verwerkingsverantwoordelijke of van een derde. (lid 1 sub f)De gerechtvaardigde belangen betreffen het
            volgende:

            <p class="dent">
              Om Fraude te voorkomen.
            </p>
          </li>
        </ul>
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        3. ONTVANGERS VAN DE PERSOONSGEGEVENS
      </template>

      <template #body>
        Persoonsgegevens kunnen door Fam Koelink B.V worden verstrekt aan derden,indien dit verenigbaar is met het in deze
        privacyverklaring genoemde doel waarvoor de gegevens zijn verzameld.
        <br>
        <br>
        Persoonsgegevens worden enkel verstrekt voor de periode en omvang dienoodzakelijk is voor de uitvoering van de
        door Fam Koelink B.V gegeven opdrachtaan de ontvangers.
        <br>
        <br>
        In alle gevallen van verstrekking van persoonsgegevens aan derden, draagt FamKoelink B.V er zorg voor dat de
        gegevens enkel voor de beoogde doeleinden wordengebruikt en overeenkomstig het wettelijk verzekerde
        beschermingsniveau wordenbewaard.
        <br>
        <br>
        Fam Koelink B.V verkoopt de gegevens van de gebruiker nooit voor commerciëledoeleinden.
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        4. BEWAARTERMIJN VAN DE GEGEVENS
      </template>

      <template #body>
        De persoonsgegevens worden door Fam Koelink B.V niet langer gebruikt ofopgeslagen dan noodzakelijk is voor het
        bereiken van de doelstellingen waarvoor degegevens worden verzameld overeenkomstig deze overeenkomst.
      </template>
    </ArticleLayout>


    <ArticleLayout>
      <template #default>
        5. RECHTEN VAN DE GEBRUIKERS
      </template>

      <template #body>
        De gebruiker van de website kan op ieder moment zijn rechten uitoefenen tenaanzien van Fam Koelink B.V.
        <br>
        <br>
        De gebruiker kan zijn verzoek tot de uitoefening van één of meer van zijn rechtenkenbaar maken aan Fam Koelink B.V
        middels één van de in deze privacyverklaringgenoemde contactgegevens van Fam Koelink B.V.
        <br>
        <br>
        Fam Koelink B.V geeft gehoor aan het verzoek van de gebruiker, tenzij het verzoekongegrond of buitensporig is.
        <br>
        <br>
        Fam Koelink B.V geeft uiterlijk binnen een maand na het verzoek reactie op hetverzoek van de gebruiker, ook
        wanneer geen gehoor wordt gegeven aan hetverzoek.
        <br>
        <br>
        De reactie op het verzoek dient duidelijk te zijn voor de gebruiker, en dient schriftelijkof via andere
        (elektronische) middelen te worden verstrekt aan de gebruiker.
        <br>
        <br>
        <i>
          a. Recht op informatie over de verwerkingen
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht op een duidelijke en transparante uitlegover de gegevensverwerking.
        <br>
        <br>
        Middels deze privacyverklaring verstrekt Fam Koelink B.V informatie over de bronvan de gegevens, de
        gegevensontvanger(s), de doelstellingen, noodzakelijkheid engrondslag van de gegevensverwerking, de waarborgen
        voor gegevensbescherming,de bewaartermijn, de contactgegevens voor klachten, de rechten van de gebruiker.
        <br>
        <br>
        <i>
          b. Recht van inzage
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om, met redelijke tussenpozen, zijnpersoonsgegevens die zijn verzameld
        in te zien.
        <br>
        <br>
        Fam Koelink B.V verstrekt de gebruiker, indien hierom is verzocht, inzage in eenoverzicht met in ieder geval de
        volgende gegevens met betrekking tot de gebruiker:
        <br>
        <ul>
          <li>
            de doelstellingen voor de gegevensverwerking;
          </li>

          <li>
            de categorieën van persoonsgegevens die worden verwerkt;
          </li>

          <li>
            de ontvangers of categorieën van ontvangers aan wie de persoonsgegevensworden doorgegeven;
          </li>

          <li>
            de bewaartermijn van de persoonsgegevens;
          </li>

          <li>
            het recht op wijziging, verwijdering, beperking, of bezwaar;
          </li>

          <li>
            het recht om een klacht in te dienen.
          </li>
        </ul>
        <br>
        Wanneer de gebruiker verzoekt tot inzage in zijn verzamelde persoonsgegevens,wordt voordat inzage wordt gegeven,
        de identiteit van de gebruiker vastgesteld doorFam Koelink B.V.
        <br>
        <br>
        Indien een kopie van de gegevens wordt verstrekt aan de gebruiker, worden voor deverstrekking van de kopie geen
        kosten in rekening gebracht, tenzij de gebruikermeerdere kopieën wil ontvangen en hier op basis van
        administratieve kosten eenredelijke vergoeding voor gevraagd kan worden.
        <br>
        <br>
        De kopie wordt schriftelijk aangeboden, waaronder begrepen in elektronische vorm.
        <br>
        <br>
        Indien de gebruiker het verzoek tot inzage elektronisch indient, wordt de kopie vande gegevens eveneens middels
        elektronische vorm verstrekt, tenzij de gebruikeranders verzoekt.
        <br>
        <br>
        Een kopie van de persoonsgegevens wordt binnen een maand na het verzoek aande gebruiker verstrekt.
        <br>
        <br>
        <i>
          c. Recht op rectificatie
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om zijn persoonsgegevens te corrigerenof aan te vullen indien deze
        niet accuraat zijn.
        <br>
        <br>
        Indien de gebruiker niet de mogelijkheid heeft om zijn persoonsgegevens zelf tecorrigeren of aan te vullen, kan de
        gebruiker Fam Koelink B.V opdragen zijnpersoonsgegevens te corrigeren of aan te vullen.
        <br>
        <br>
        Fam Koelink B.V brengt alle ontvangers van de persoonsgegevens op de hoogte vande gewijzigde gegevens, tenzij dit
        onmogelijk blijkt of onevenredige inspanning vergtin verhouding tot de belangen van de gebruiker. Fam Koelink B.V
        verstrekt degebruiker informatie over deze ontvangers indien de gebruiker hierom verzoekt.
        <br>
        <br>
        <i>
          d. Recht op gegevenswissing
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om zijn verzamelde persoonsgegevensdoor Fam Koelink B.V te laten
        wissen, indien sprake is van één van de in artikel 17,lid 1 Algemene verordening gegevensbescherming genoemde
        situaties.
        <br>
        <br>
        Tevens heeft de gebruiker het recht om 'vergeten te worden' indien Fam Koelink B.Vpersoonsgegevens van de
        gebruiker openbaar heeft gemaakt en de gebruikerverzoekt om uitwissing van zijn gegevens. Fam Koelink B.V dient in
        dit geval denodige maatregelen te nemen om andere verwerkingsverantwoordelijken op dehoogte te brengen dat de
        gebruiker zijn persoonsgegevens of enig kopie hiervan wiluitwissen.
        <br>
        <br>
        Er hoeft geen gehoor te worden gegeven aan een verzoek tot uitwissing vanpersoonsgegevens indien de verwerking van
        de gegevens nodig is voor één van dein artikel 17, lid 3 Algemene verordening gegevensbescherming genoemde
        redenen.
        <br>
        <br>
        <i>
          e. Recht op beperking van de verwerking
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om de verwerking van zijnpersoonsgegevens te beperken indien sprake is
        van één van de in artikel 18, lid 1Algemene verordening gegevensbescherming genoemde situaties.
        <br>
        <br>
        In het geval van de uitoefening van de beperking van depersoonsgegevensverwerking mogen de gegevens enkel worden
        verwerkt:
        <br>
        <ul>
          <li>
            met de toestemming van de gebruiker;
          </li>
          <li>
            voor de instelling, uitoefening of onderbouwing van een rechtsvordering;
          </li>
          <li>
            ter bescherming van de rechten van derden of om gewichtige redenen vanalgemeen belang voor de Europese Unie of
            een lidstaat.
          </li>
        </ul>
        <br>
        Fam Koelink B.V brengt alle ontvangers van de persoonsgegevens op de hoogte vande beperking van de
        gegevensverwerking, tenzij dit onmogelijk blijkt of onevenredigeinspanning vergt in verhouding tot de belangen van
        de gebruiker. Fam Koelink B.V
        verstrekt de gebruiker informatie over deze ontvangers indien de gebruiker hieromverzoekt.
        <br>
        <br>
        <i>
          f. Recht op overdraagbaarheid van gegevens
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om zijn persoonsgegevens te verkrijgenvan Fam Koelink B.V in een
        gestructureerde, gangbare en machineleesbare vorm endoor te geven aan een andere verwerkingsverantwoordelijke,
        zonder dat FamKoelink B.V hem hierbij hindert, indien sprake is van één van de in artikel 20, lid 1Algemene
        verordening gegevensbescherming genoemde situaties.
        <br>
        <br>
        Indien de gebruiker zijn recht op overdraagbaarheid van gegevens uitoefent, heeft degebruiker tevens het recht dat
        de persoonsgegevens rechtstreeks van de ene naarde andere verwerkingsverantwoordelijke worden doorgestuurd, tenzij
        dit technischniet mogelijk is.
        <br>
        <br>
        De uitoefening van het recht op overdraagbaarheid laat het recht totgegevenswissing onverlet. Dat recht geldt niet
        voor de verwerking die noodzakelijk isvoor de vervulling van een taak van algemeen belang of van een taak in het
        kadervan de uitoefening van het openbaar gezag dat aan Fam Koelink B.V opgedragen is.
        <br>
        <br>
        De uitoefening van het recht op overdraagbaarheid doet geen afbreuk aan derechten en vrijheden van derden.
        <br>
        <br>
        <i>
          g. Recht van bezwaar
        </i>
        <br>
        <br>
        De gebruiker van de website heeft te allen tijde het recht om bezwaar te maken,vanwege zijn specifieke situatie,
        tegen de verwerking van zijn persoonsgegevensdoor Fam Koelink B.V.
        <br>
        <br>
        In bovenstaand geval zal Fam Koelink B.V staken met de verwerking van depersoonsgegevens van de gebruiker, tenzij
        Fam Koelink B.V dwingendegerechtvaardigde gronden voor de verwerking kan aanvoeren die zwaarder wegendan de
        belangen, rechten en vrijheden van de gebruiker, of die verband houden metde instelling, uitoefening of
        onderbouwing van een rechtsvordering.
        <br>
        <br>
        Bij verwerking van de persoonsgegevens voor direct marketing doeleinden, heeft degebruiker te allen tijde het
        recht om bezwaar te maken tegen de verwerking van zijnpersoonsgegevens.
        <br>
        <br>
        Indien de gebruiker bezwaar maakt tegen gegevensverwerking ten behoeve vandirect marketing, worden de gegevens
        niet langer voor deze doeleinden verwerkt.
        <br>
        <br>
        <i>
          h. Klachtrecht
        </i>
        <br>
        <br>
        De gebruiker van de website heeft het recht om een klacht in te dienen metbetrekking tot de verwerking van zijn
        persoonsgegevens door Fam Koelink B.V bij deAutoriteit Persoonsgegevens.
        <br>
        <br>
        Zowel klachten met betrekking tot de verwerking van de persoonsgegevens van degebruiker, als klachten met
        betrekking tot onjuiste naleving van de toepasselijkewetgeving kunnen worden ingediend.
        <br>
        <br>
        De Autoriteit Persoonsgegevens is in Nederland aangesteld voor het houden vantoezicht op
        persoonsgegevensverwerking. Informatie met betrekking tot de AutoriteitPersoonsgegevens kan gevonden worden op
        https://autoriteitpersoonsgegevens.nl/.
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        6. HET GEBRUIK VAN COOKIES
      </template>

      <template #body>
        Fam Koelink B.V maakt gebruik van cookies.
        <br>
        <br>
        Cookies zijn kleine hoeveelheden data die op de browser van de gebruiker wordengeplaatst op het moment dat de
        gebruiker de website bezoekt, en bij een volgendbezoek van de gebruiker naar de server van de website
        teruggestuurd worden.
        <br>
        <br>
        Door het plaatsen van cookies kunnen gebruikers van elkaar worden onderscheidenen bij een nieuw bezoek aan de
        website kunnen de gebruikers worden herkend.Hierdoor kan het gebruik van de gebruiker van de website bijgehouden
        worden.
        <br>
        <br>
        Het plaatsen van cookies dient ter verbetering van de prestaties en het functionerenvan de website.
        <br>
        <br>
        Voor meer informatie over het gebruik van cookies, kan geraadpleegd worden:
        <p class="dent">
          In het cookiebeleid van de app.
        </p>
      </template>
    </ArticleLayout>

    <ArticleLayout>
      <template #default>
        7. WIJZIGING VAN DE PRIVACYVERKLARING
      </template>

      <template #body>
        Deze privacyverklaring kan in verband met nieuwe ontwikkelingen van de website ofeen aanpassing van de wettelijke
        verplichtingen gewijzigd worden.
        <br>
        <br>
        De meest recente versie van de privacyverklaring kan geraadpleegd worden op dewebsite. Hierbij staat de laatste
        wijzigingsdatum vermeld.
      </template>
    </ArticleLayout>
  </div>
</template>


<script>
import ArticleLayout from '@/components/ArticleLayout.vue'

export default {
  name: 'TermsOfService',
  components: {
    ArticleLayout
  },
  setup() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  padding: 24px;
  font-family: var(--font-family-inter);
  display: flex;
  flex-direction: column;
  gap: 32px;

  .dent {
    padding: 0 0 0 24px;
  }
}</style>
